import React, { useRef, useEffect } from 'react';
import { Formik } from 'formik';
import { Box, Grid, Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import { SearchDetailFormInput } from './SearchDetailFormInput.js';
import { FormInput } from './FormInput.js';
import { FormModal } from './FormModal.js';
import { TimeRange } from '../../models/TimeRange.js';
import { SearchModeToParam } from '../../utils/query.js';

// libs/src/components/Form/SearchDetailForm.tsx
const SearchDetailForm = ({
  keys = [{
    label: '日時',
    value: 'datetime',
    enabled: false,
    type: 'datetime'
  }, {
    label: 'ミッション名',
    value: 'name',
    enabled: false,
    type: 'string'
  }, {
    label: 'ロケット',
    value: 'rocket',
    enabled: false,
    type: 'string'
  }],
  queries = [{
    key: 'limit',
    value0: 100
  }],
  sx,
  onSubmit,
  ...props
}) => {
  const RenderForm = ({
    formik
  }) => {
    const formikRef = useRef(formik);
    formikRef.current = formik;
    // 初期クエリ変更時のみフィールドを更新する
    useEffect(() => {
      formikRef.current.setFieldValue('queries', [...queries].filter(q => q.key !== 'limit'));
      const limit = [...queries].filter(q => q.key === 'limit')[0];
      formikRef.current.setFieldValue('limit', limit ? limit.value0 : 100);
    }, [queries]);
    const restKeys = (query = null) => keys.filter(k => {
      return formik.values.queries.filter(q => {
        if (query && q.key === query.key) {
          return false;
        }
        return q.key === k.value;
      }).length === 0;
    }).map(k => {
      return {
        ...k,
        enabled: true
      };
    });
    const AddKeyModal = () => {
      return restKeys().length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormModal, {
        sx: {
          mb: 2
        },
        title: "\u691C\u7D22\u6761\u4EF6\u3092\u8FFD\u52A0\u3059\u308B",
        childrenList: [],
        FormAttrs: {},
        onSubmit: async v => {
          //キーがかぶっている場合は上書き
          for (let i = 0; i < formik.values.queries.length; i++) {
            if (formik.values.queries[i].key === v.key) {
              formik.setFieldValue('queries[' + i + ']', v);
              return;
            }
          }
          formik.setFieldValue('queries[' + formik.values.queries.length + ']', v);
          formik.handleSubmit();
        },
        Form: ({
          onSubmit
        }) => /*#__PURE__*/React.createElement(SearchDetailFormInput, {
          onSubmit: onSubmit,
          keys: restKeys(),
          name: "new_queriy",
          formik: formik,
          sx: {
            mb: 1
          }
        })
      }, /*#__PURE__*/React.createElement(Button, {
        sx: {
          ml: 0.25,
          pr: 0.25,
          width: '100%'
        },
        variant: "outlined",
        color: "primary"
      }, /*#__PURE__*/React.createElement(AddIcon, {
        fontSize: "small"
      }), "\u691C\u7D22\u6761\u4EF6\u3092\u8FFD\u52A0"))) : /*#__PURE__*/React.createElement(Button, {
        sx: {
          ml: 0.25,
          pr: 0.25,
          mb: 2,
          width: '100%',
          height: '100%'
        },
        variant: "outlined",
        color: "inherit",
        disabled: true
      }, "\u8FFD\u52A0\u53EF\u80FD\u306A\u691C\u7D22\u6761\u4EF6\u306F\u3042\u308A\u307E\u305B\u3093");
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, formik.values.queries.map((q, i) => {
      return /*#__PURE__*/React.createElement(SearchDetailFormInput, {
        key: "1",
        keys: restKeys(q),
        name: 'queries[' + i + ']',
        formik: formik,
        sx: {
          mb: 2
        },
        onChange: v => {
          //キーがかぶっている場合は上書き
          for (let i = 0; i < formik.values.queries.length; i++) {
            if (formik.values.queries[i].key === v.key) {
              formik.setFieldValue('queries[' + i + ']', v);
            }
          }
        },
        onDatetimeChange: v => {
          //キーがかぶっている場合は上書き
          for (let i = 0; i < formik.values.queries.length; i++) {
            if (formik.values.queries[i].key === v.key) {
              formik.setFieldValue('queries[' + i + ']', v);
            }
          }
          formik.handleSubmit();
        },
        onDelete: v => {
          formik.setFieldValue('queries', formik.values.queries.slice(0, i).concat(formik.values.queries.slice(i + 1)));
          formik.handleSubmit();
        }
      });
    }), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 3,
      sm: 2
    }, /*#__PURE__*/React.createElement(AddKeyModal, null)), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 1
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 9,
      sm: 10,
      sx: {
        pb: 0.5
      }
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: formik.handleSubmit,
      sx: {
        ml: 0.25,
        width: '100%',
        height: '100%'
      },
      variant: "contained"
    }, /*#__PURE__*/React.createElement(SearchIcon, {
      fontSize: "small"
    }), "\u691C\u7D22")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 3,
      sm: 2
    }, /*#__PURE__*/React.createElement(FormInput, {
      name: "limit",
      title: "\u691C\u7D22\u6570\u306E\u4E0A\u9650",
      formik: formik
    }))));
  };
  let limit = 100;
  let searchQuery = [...queries].filter(q => q.key !== 'limit');
  if (searchQuery.length !== queries.length) {
    const limitQuery = [...queries].filter(q => q.key === 'limit');
    if (limitQuery.length) {
      limit = Number(limitQuery[0].value0);
    }
  }
  return /*#__PURE__*/React.createElement(Box, props, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      queries: searchQuery,
      limit
    },
    onSubmit: async (values, {
      setSubmitting
    }) => {
      setSubmitting(false);
      let queries = [...values.queries].map(q => {
        if (q.type === 'datetime') {
          return TimeRange.fromMode(q.value0, q.mode, q.value1).toString(q.key);
        } else {
          return SearchModeToParam(q);
        }
      });
      queries.push('limit=' + values.limit);
      onSubmit && (await onSubmit(queries));
    }
  }, formik => /*#__PURE__*/React.createElement(RenderForm, {
    formik: formik
  })));
};

export { SearchDetailForm };
